<template lang="pug">
  #app
    Header
    Navigation(:mode="mode" :title="title")
    StripeBar(v-if="mode === 3" :title="title")
    router-view(
      @change_mode="change_mode"
    )
    Footer
</template>

<script lang="js">
import Header from '@/components/module/Header.vue';
import Navigation from '@/components/module/Navigation.vue';
import StripeBar from '@/components/module/StripeBar.vue';
import Footer from '@/components/module/Footer.vue';

export default {
  data: () => ({
    mode: 1,
    title: 'まずは質問に答えて相続関係図を完成させます',
  }),

  components: {
    Header,
    Navigation,
    Footer,
    StripeBar,
  },

  watch: {
    $route: (to, from) =>
        window.scrollTo(0, 0),
  },

  methods: {
    change_mode(mode) {
      this.mode = mode;
      if (mode === 2) {
        this.title = '遺産を入力して配分表を作成します';
      }
      if (mode === 3) {
        this.title = 'シミュレーション結果';
      }
      if (mode === 4) {
        this.title = 'メールフォーム';
      }
    },
  },
};

</script>

<style lang="sass" scoped>
#app
  width: 100%
</style>

<style lang="sass">
@import "./assets/sass/base.sass"
</style>
